import { Alert, Badge, Table } from "flowbite-react";
import TitleStripe from "../TitleStripe";
import NoOcurrence from "./NoOcurrence";
import { formatToReal, getImageURLScore } from "../../../utils/utils";
import moment from "moment";
import AvisoCard from "./AvisoCard";
import ParticipacaoEmEmpresas from "./ParticipacaoEmEmpresas";

const AvaliaMaxPF = ({ data }) => {
  const report = data?.reports?.[0];
  const registration = report?.registration;
  const score = report?.score;
  const negativeData = report?.negativeData;
  const facts = report?.facts;
  const partner = report?.partner;
  const history = facts?.inquiry?.inquiryResponse;

  const renderNegativationTable = (title, dataArray, columns) => (
    <div className="mt-3">
      <TitleStripe className="mb-2">{title}</TitleStripe>
      {dataArray?.length > 0 ? (
        <>
          <div className="overflow-x-hidden border-gray-100 border rounded-lg mt-3">
            <Table striped>
              <Table.Head>
                {columns.map((col, idx) => (
                  <Table.HeadCell
                    key={idx}
                    className="text-center text-black"
                    style={{ background: "#3EED98" }}
                  >
                    {col.label}
                  </Table.HeadCell>
                ))}
              </Table.Head>
              <Table.Body className="divide-y">
                {dataArray.map((item, index) => (
                  <Table.Row
                    key={index}
                    className="bg-white dark:border-gray-700 dark:bg-gray-800"
                  >
                    {columns.map((col, idx) => (
                      <Table.Cell
                        key={idx}
                        className="text-center py-1 text-black"
                      >
                        {col.format
                          ? col.format(item[col.key])
                          : item[col.key] ?? "-"}
                      </Table.Cell>
                    ))}
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </div>
          <span className="mt-2 block text-xs italic">
            Exibindo as últimas 5 ocorrências
          </span>
        </>
      ) : (
        <NoOcurrence />
      )}
    </div>
  );

  return (
    <>
      {data?.statusRetorno == 1 ? (
        <>
          <div className="mt-6 border rounded-2xl shadow p-6 bg-white">
            <h3 className="text-lg font-bold mb-4 border-b pb-2">
              📄 Dados Cadastrais
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700">
              <div>
                <div className="mb-2">
                  <strong>Nome completo:</strong>{" "}
                  {registration?.consumerName || "Indisponível"}
                </div>
                <div className="mb-2 flex flex-wrap items-center gap-2">
                  <strong>Data de nascimento:</strong>{" "}
                  {registration?.birthDate
                    ? moment(registration.birthDate).format("DD/MM/YYYY")
                    : "Indisponível"}
                  {registration?.birthDate && (
                    <span className="bg-primary text-white px-2 py-0.5 rounded-md text-xs font-semibold">
                      {moment().diff(
                        moment(registration.birthDate, "YYYY-MM-DD"),
                        "years"
                      )}{" "}
                      anos
                    </span>
                  )}
                </div>
              </div>
              <div>
                <div className="mb-2">
                  <strong>CPF:</strong>{" "}
                  {registration?.documentNumber || "Indisponível"}
                </div>
                <div className="mb-2">
                  <strong>Nome da mãe:</strong>{" "}
                  {registration?.motherName || "Indisponível"}
                </div>
              </div>
            </div>
          </div>

          <div>
            <TitleStripe className="mb-5">
              Participações societárias
            </TitleStripe>
            {partner?.partnershipResponse?.length > 0 ? (
              <>
                <div className="overflow-x-hidden border-gray-100 border rounded-lg mt-3">
                  <Table striped>
                    <Table.Head>
                      <Table.HeadCell
                        className="text-center text-black"
                        style={{ background: "#3EED98" }}
                      >
                        Empresa
                      </Table.HeadCell>
                      <Table.HeadCell
                        className="text-center text-black"
                        style={{ background: "#3EED98" }}
                      >
                        CNPJ
                      </Table.HeadCell>
                      <Table.HeadCell
                        className="text-center text-black"
                        style={{ background: "#3EED98" }}
                      >
                        UF
                      </Table.HeadCell>
                      <Table.HeadCell
                        className="text-center text-black"
                        style={{ background: "#3EED98" }}
                      >
                        Participação
                      </Table.HeadCell>
                      <Table.HeadCell
                        className="text-center text-black"
                        style={{ background: "#3EED98" }}
                      >
                        Situação
                      </Table.HeadCell>
                      <Table.HeadCell
                        className="text-center text-black"
                        style={{ background: "#3EED98" }}
                      >
                        Atualização
                      </Table.HeadCell>
                    </Table.Head>
                    <Table.Body className="divide-y">
                      {partner.partnershipResponse.map((empresa, index) => (
                        <Table.Row
                          key={index}
                          className="bg-white dark:border-gray-700 dark:bg-gray-800"
                        >
                          <Table.Cell className="text-center py-1 text-black">
                            {empresa.companyName || "-"}
                          </Table.Cell>
                          <Table.Cell className="text-center py-1 text-black">
                            {empresa.businessDocument || "-"}
                          </Table.Cell>
                          <Table.Cell className="text-center py-1 text-black">
                            {empresa.companyState || "-"}
                          </Table.Cell>
                          <Table.Cell className="text-center py-1 text-black">
                            {empresa.participationPercentage ?? "-"} %
                          </Table.Cell>
                          <Table.Cell className="text-center py-1 text-black">
                            {empresa.companyStatus || "-"}
                          </Table.Cell>
                          <Table.Cell className="text-center py-1 text-black">
                            {empresa.updateDate
                              ? moment(empresa.updateDate).format("DD/MM/yyyy")
                              : "-"}
                          </Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.Body>
                  </Table>
                </div>
                <span className="mt-2 block text-xs italic">
                  Total: {partner.partnershipResponse.length} empresa(s)
                  encontrada(s)
                </span>
              </>
            ) : (
              <NoOcurrence />
            )}
          </div>

          <TitleStripe className="mt-6">Score de Risco</TitleStripe>
          <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm mt-2 flex flex-col items-center text-xs">
            {score?.score ? (
              <>
                <div className="flex flex-col items-center">
                  <img
                    src={getImageURLScore(score.score)}
                    alt="Score"
                    className="w-[320px]"
                  />
                  <div className="text-center text-lg font-semibold mt-2">
                    Score: {score.score}
                  </div>
                  <div className="text-gray-600 mt-1">
                    Faixa: <span className="font-medium">{score.range}</span> —
                    Risco estimado:{" "}
                    <span className="font-medium">{score.defaultRate}%</span>
                  </div>
                </div>
                <p className="mt-3 text-center text-gray-500 max-w-lg">
                  Este score é uma estimativa de risco baseada em modelos
                  estatísticos. A decisão final sobre concessão de crédito é de
                  responsabilidade exclusiva do credor.
                </p>
              </>
            ) : (
              <Alert color="gray" className="mt-2 text-sm">
                {score?.message || "Score indisponível"}
              </Alert>
            )}
          </div>

          <div>
            <TitleStripe className="mb-5">Histórico de consultas</TitleStripe>
            {history?.length > 0 ? (
              <>
                <div className="overflow-x-hidden border-gray-100 border rounded-lg mt-3">
                  <Table striped>
                    <Table.Head>
                      <Table.HeadCell
                        className="text-center text-black"
                        style={{ background: "#3EED98" }}
                      >
                        Data
                      </Table.HeadCell>
                      <Table.HeadCell
                        className="text-center text-black"
                        style={{ background: "#3EED98" }}
                      >
                        Segmento
                      </Table.HeadCell>
                      <Table.HeadCell
                        className="text-center text-black"
                        style={{ background: "#3EED98" }}
                      >
                        Dias
                      </Table.HeadCell>
                    </Table.Head>
                    <Table.Body className="divide-y">
                      {history.map((item, index) => (
                        <Table.Row
                          key={index}
                          className="bg-white dark:border-gray-700 dark:bg-gray-800"
                        >
                          <Table.Cell className="font-medium text-black dark:text-white text-center py-1">
                            {moment(item?.occurrenceDate).format(
                              "DD/MM/yyyy"
                            ) || "-"}
                          </Table.Cell>
                          <Table.Cell className="text-center py-1 text-black">
                            {item?.segmentDescription || "-"}
                          </Table.Cell>
                          <Table.Cell className="text-center py-1 text-black">
                            {item?.daysQuantity ?? "-"}
                          </Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.Body>
                  </Table>
                </div>
                <span className="mt-2 block text-xs italic">
                  Exibindo as últimas {history.length} ocorrências
                </span>
              </>
            ) : (
              <NoOcurrence />
            )}
          </div>

          <TitleStripe className="mt-6">Quadro de avisos</TitleStripe>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
            <AvisoCard
              title="Pend. Comerciais"
              hasRestrictions={negativeData?.pefin?.summary?.count > 0}
              messageError={`${negativeData?.pefin?.summary?.count} ocorrências`}
            />
            <AvisoCard
              title="Pend. Financeiras"
              hasRestrictions={negativeData?.refin?.summary?.count > 0}
              messageError={`${negativeData?.refin?.summary?.count} ocorrências`}
            />
            <AvisoCard
              title="Protestos"
              hasRestrictions={negativeData?.notary?.summary?.count > 0}
              messageError={`${negativeData?.notary?.summary?.count} ocorrências`}
            />
            <AvisoCard
              title="Cheques S/F"
              hasRestrictions={negativeData?.check?.summary?.count > 0}
              messageError={`${negativeData?.check?.summary?.count} ocorrências`}
            />
          </div>

          {/* Negativação - PEFIN */}
          {renderNegativationTable(
            "Pendências Comerciais",
            negativeData?.pefin?.pefinResponse,
            [
              {
                key: "occurrenceDate",
                label: "Data",
                format: (val) => moment(val).format("DD/MM/yyyy"),
              },
              { key: "creditorName", label: "Credor" },
              { key: "contractId", label: "Contrato" },
              { key: "amount", label: "Valor", format: formatToReal },
            ]
          )}

          {/* Negativação - REFIN */}
          {renderNegativationTable(
            "Pendências Financeiras",
            negativeData?.refin?.refinResponse,
            [
              {
                key: "occurrenceDate",
                label: "Data",
                format: (val) => moment(val).format("DD/MM/yyyy"),
              },
              { key: "creditorName", label: "Credor" },
              { key: "contractId", label: "Contrato" },
              { key: "amount", label: "Valor", format: formatToReal },
            ]
          )}

          {/* Negativação - Protestos */}
          {renderNegativationTable(
            "Protestos",
            negativeData?.notary?.notaryResponse,
            [
              {
                key: "occurrenceDate",
                label: "Data",
                format: (val) => moment(val).format("DD/MM/yyyy"),
              },
              { key: "officeNumber", label: "Cartório" },
              { key: "amount", label: "Valor", format: formatToReal },
            ]
          )}

          {/* Negativação - Cheques sem fundo */}
          {renderNegativationTable(
            "Cheques Sem Fundos",
            negativeData?.check?.checkResponse,
            [
              {
                key: "occurrenceDate",
                label: "Data",
                format: (val) => moment(val).format("DD/MM/yyyy"),
              },
              { key: "bankName", label: "Banco" },
              { key: "checkNumber", label: "Nº Cheque" },
              { key: "checkCount", label: "Qtd." },
            ]
          )}
        </>
      ) : (
        <Alert color="gray" className="mt-4">
          Consulta indisponível no momento.
        </Alert>
      )}
    </>
  );
};

export default AvaliaMaxPF;
